const translations = {
  "en": {
    "Ask me to get more clarity on your positions.": "Ask me to get more clarity on your positions.",
    "Want a deeper dive into this signal?": "Want a deeper dive into this signal?",
    "What do you want to explore together today?": "What do you want to explore together today?"
  },
  "zh-tw": {
    "Ask me to get more clarity on your positions.": "對倉位有疑問？隨時問我，為你解析。",
    "Want a deeper dive into this signal?": "想深入挖掘這條訊號？",
    "What do you want to explore together today?": "今天想一起探索些什麼？"
  }
};

export default translations;
